<div class="wa-editor">
  <div class="toolbar">
    <button type="button" class="tool-btn" (click)="format('bold')"><b>B</b></button>
    <button type="button" class="tool-btn italic" (click)="format('italic')">i</button>
    <button type="button" class="tool-btn" (click)="format('strike')">S</button>
    <button type="button" class="tool-btn" (click)="format('mono')">
      &#96;&#96;&#96;
    </button>

    <div class="emoji-wrapper">
      <button type="button" class="tool-btn" (click)="toggleEmoji()">😊</button>

      <div class="emoji-picker" *ngIf="showEmojiPicker">
        <button type="button" *ngFor="let e of emojis" (click)="pickEmoji(e)">
          {{ e }}
        </button>
      </div>
    </div>

    <div class="spacer"></div>

    <div class="count" [class.limit]="currentLength >= charLimit">
      {{ currentLength }} / {{ charLimit }}
    </div>
  </div>

  <div #editor class="editor" contenteditable="true" [attr.placeholder]="placeholder" (input)="onInput()"
    (keydown)="onKeyDown($event)" (paste)="onPaste($event)" (blur)="onTouched()" spellcheck="false">
  </div>
</div>